





































import { Component, Vue, Prop } from "vue-property-decorator";
import rightArrow from "../../../assets/images/right-arrow.png";
import downloadIcon from "../../../assets/images/download-icon.png";
@Component({
  components: {}
})
export default class DataCard extends Vue {
  @Prop(Object) info: any;
  private rightArrow = rightArrow;
  private downloadIcon = downloadIcon;
  goDetail(news) {
    this.$router.push({ name: "详情", params: { id: news.id } });
  }
  handleJump() {
    this.$router.push({ name: this.info.title });
  }
}
